import { render } from "./MallRefundTrend.vue?vue&type=template&id=74d0d9d6&scoped=true"
import script from "./MallRefundTrend.vue?vue&type=script&lang=js"
export * from "./MallRefundTrend.vue?vue&type=script&lang=js"

import "./MallRefundTrend.vue?vue&type=style&index=0&id=74d0d9d6&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d0d9d6"]])

export default __exports__